import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITreatyState } from '../../store/reducers/treaty.reducer';
import { Store } from '@ngrx/store';
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";
import {Configuration} from "@shared/models/configuration";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";


@Component({
    standalone: false,
    selector: 'lib-treaty-type',
  templateUrl: './treaty-type.component.html',
  styleUrls: ['./treaty-type.component.scss']
})

export class TreatyTypeComponent implements OnInit, OnDestroy {
  currentMenu: string;
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  private config: any;
  constructor(private store: Store<ITreatyState>,
              private router: Router) {
    this.sourceKey = 'TreatyRepository';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'treaty',
        title: 'Treaty',
        type: 'Treaty',
        relativeUrl: 'treaty'
      }
    ];
  }

  ngOnInit() {
    this.config = Configuration.getSmartGridConfig(this.sourceKey);
    this.config.Parameters['PARENT_ID'] = "treaties";
  }

  onGridCellValueChange($event) {
    console.log("Show me the event:::", $event);
    console.log("Here is the :::", $event.cells['Name'].value);
    const name = $event.cells['Name'].value;
    switch(name){
      case 'treaty-documents':
        this.router.navigateByUrl(`treaty/documents`);
        break;
      case 'other-documents':
        this.router.navigateByUrl(`treaty/other-documents`);
        break;
      case 'social-security-documents' :
        this.router.navigateByUrl(`treaty/social-security-documents`);
        break;
    }
  }
  ngOnDestroy() {}
}
